






import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import { Book } from '@/modules/Book/interfaces/book'
import AppSystemInfoCard from '@/components/AppSystemInfoCard.vue'

@Component({
  components: {
    AppSystemInfoCard
  }
})
export default class BookDetailAdditional extends Vue {
  @Prop({ type: Object as () => Book }) readonly book!: Book
}
